import { NgModule } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule, NgxMatNativeDateModule, NgxMatDateFormats, NGX_MAT_DATE_FORMATS } from '@angular-material-components/datetime-picker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatTimepickerModule } from 'mat-timepicker';
import { MatRadioModule } from "@angular/material/radio";

@NgModule({
    imports: [
        MatFormFieldModule,
        MatSelectModule,
        MatDatepickerModule,
        MatInputModule,
        MatNativeDateModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        MatTableModule,
        MatSlideToggleModule,
        MatButtonToggleModule,
        MatTabsModule,
        NgxMatDatetimePickerModule,
        NgxMatTimepickerModule,
        NgxMatNativeDateModule,
        DragDropModule,
        MatTimepickerModule,
        MatRadioModule
    ],
    exports: [
        MatFormFieldModule,
        MatSelectModule,
        MatDatepickerModule,
        MatInputModule,
        MatNativeDateModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        MatTableModule,
        MatSlideToggleModule,
        MatButtonToggleModule,
        MatTabsModule,
        NgxMatDatetimePickerModule,
        NgxMatTimepickerModule,
        NgxMatNativeDateModule,
        DragDropModule,
        MatTimepickerModule,
        MatRadioModule
    ],
    providers: [
    ],
    declarations: []
})
export class MaterialModule { }
